import React, { useState } from "react";
import PageHero from "../components/dental/PageHero";
import SectionTitle from "../components/dental/SectionTitle";
import Button from "../components/dental/Button";
import { Phone, Mail, MapPin, Clock, Check } from "lucide-react";
import { siteInfo } from "../mock";
import { IMAGES, SERVICES } from "../data/site";
import { SPA_SERVICES } from "../data/site";

const hours = [
  ["Monday", "9am – 5pm"],
  ["Tuesday", "9am – 2pm"],
  ["Wednesday", "Closed"],
  ["Thursday", "9am – 7pm"],
  ["Friday", "9am – 3pm"],
  ["Saturday", "By Appointment"],
  ["Sunday", "Closed"],
];

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    date: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    try {
      const list = JSON.parse(localStorage.getItem("edental_appointments") || "[]");
      list.push({ ...form, ts: Date.now() });
      localStorage.setItem("edental_appointments", JSON.stringify(list));
    } catch (_) {}
    setSubmitted(true);
    setForm({ name: "", email: "", phone: "", service: "", date: "", message: "" });
    setTimeout(() => setSubmitted(false), 6000);
  };

  return (
    <>
      <PageHero
        subtitle="Get In Touch"
        title="Contact Us"
        breadcrumb="Contact"
        image={IMAGES.contact_banner}
      />

      <section className="bg-[#FBF8F1] py-14 md:py-16">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-3 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <SectionTitle script="Request An Appointment" title="" subtitle="We'll Be In Touch" align="left" />
            <form onSubmit={onSubmit} className="mt-6 grid sm:grid-cols-2 gap-3">
              <div className="sm:col-span-1">
                <label className="font-cinzel text-[10px] uppercase tracking-[0.24em] text-[#7D6A42] block mb-1.5">Full Name *</label>
                <input required value={form.name} onChange={update("name")} type="text"
                  className="w-full px-3.5 py-2.5 bg-[#ffffff] border border-[#B79A68]/40 text-[#20322E] placeholder-[#B79A68]/40 focus:outline-none focus:border-[#B79A68]" />
              </div>
              <div className="sm:col-span-1">
                <label className="font-cinzel text-[10px] uppercase tracking-[0.24em] text-[#7D6A42] block mb-1.5">Email *</label>
                <input required value={form.email} onChange={update("email")} type="email"
                  className="w-full px-3.5 py-2.5 bg-[#ffffff] border border-[#B79A68]/40 text-[#20322E] focus:outline-none focus:border-[#B79A68]" />
              </div>
              <div className="sm:col-span-1">
                <label className="font-cinzel text-[10px] uppercase tracking-[0.24em] text-[#7D6A42] block mb-1.5">Phone</label>
                <input value={form.phone} onChange={update("phone")} type="tel"
                  className="w-full px-3.5 py-2.5 bg-[#ffffff] border border-[#B79A68]/40 text-[#20322E] focus:outline-none focus:border-[#B79A68]" />
              </div>
              <div className="sm:col-span-1">
                <label className="font-cinzel text-[10px] uppercase tracking-[0.24em] text-[#7D6A42] block mb-1.5">Preferred Date</label>
                <input value={form.date} onChange={update("date")} type="date"
                  className="w-full px-3.5 py-2.5 bg-[#ffffff] border border-[#B79A68]/40 text-[#20322E] focus:outline-none focus:border-[#B79A68] [color-scheme:light]" />
              </div>
              <div className="sm:col-span-2">
                <label className="font-cinzel text-[10px] uppercase tracking-[0.24em] text-[#7D6A42] block mb-1.5">Service of Interest</label>
                <select value={form.service} onChange={update("service")}
                  className="w-full px-3.5 py-2.5 bg-[#ffffff] border border-[#B79A68]/40 text-[#20322E] focus:outline-none focus:border-[#B79A68]">
                  <option value="">Please select</option>
                  <optgroup label="Dental Services">
                    {SERVICES.map((s) => <option key={s.slug} value={s.name}>{s.name}</option>)}
                  </optgroup>
                  <optgroup label="Spa Services">
                    {SPA_SERVICES.map((s) => <option key={s.slug} value={s.name}>{s.name}</option>)}
                  </optgroup>
                  <option value="Other">Other / Not sure</option>
                </select>
              </div>
              <div className="sm:col-span-2">
                <label className="font-cinzel text-[10px] uppercase tracking-[0.24em] text-[#7D6A42] block mb-1.5">Message</label>
                <textarea rows={4} value={form.message} onChange={update("message")}
                  className="w-full px-3.5 py-2.5 bg-[#ffffff] border border-[#B79A68]/40 text-[#20322E] focus:outline-none focus:border-[#B79A68]" />
              </div>
              <div className="sm:col-span-2">
                <button type="submit"
                  className="w-full bg-gradient-to-b from-[#B79A68] to-[#8D7448] hover:from-[#C8AE7F] hover:to-[#A18354] text-[#ffffff] py-2.5 uppercase text-[11px] tracking-[0.3em] font-semibold font-cinzel transition-all">
                  Submit Request
                </button>
              </div>
              {submitted && (
                <div className="sm:col-span-2 flex items-center gap-2 text-[#5F4F30] text-sm">
                  <Check size={16} className="text-[#7D6A42]" />
                  Thank you. Our concierge will reach out within one business day.
                </div>
              )}
            </form>
          </div>

          <aside>
            <div className="border border-[#B79A68]/40 p-5 md:p-6 bg-[#ffffff] space-y-4">
              <h3 className="font-cinzel gold-gradient-text uppercase tracking-[0.2em] text-sm">Visit Us</h3>
              <div className="flex gap-3 items-start text-[#4E5750]/85 text-sm">
                <MapPin size={16} className="text-[#7D6A42] mt-0.5" />
                <div>{siteInfo.addressLine1}<br />{siteInfo.addressLine2}</div>
              </div>
              <div className="flex gap-3 items-center text-[#4E5750]/85 text-sm">
                <Phone size={16} className="text-[#7D6A42]" />
                <a href={`tel:${siteInfo.phoneRaw}`} className="hover:text-[#5F4F30]">{siteInfo.phoneFormatted}</a>
              </div>
              <div className="flex gap-3 items-center text-[#4E5750]/85 text-sm">
                <Mail size={16} className="text-[#7D6A42]" />
                <a href={`mailto:${siteInfo.email}`} className="hover:text-[#5F4F30] break-all">{siteInfo.email}</a>
              </div>
              <div className="h-px bg-[#B79A68]/20" />
              <h3 className="font-cinzel gold-gradient-text uppercase tracking-[0.2em] text-sm flex items-center gap-2">
                <Clock size={14} /> Hours
              </h3>
              <ul className="text-sm text-[#4E5750]/85 space-y-1.5">
                {hours.map(([d, h]) => (
                  <li key={d} className="flex justify-between">
                    <span>{d}</span>
                    <span className={h === "Closed" ? "text-[#7D6A42]" : ""}>{h}</span>
                  </li>
                ))}
              </ul>
              <Button href={`tel:${siteInfo.phoneRaw}`} className="w-full text-center mt-1">Call Us Now</Button>
            </div>
          </aside>
        </div>
      </section>

      <section className="bg-[#ffffff] border-t border-[#B79A68]/15">
        <iframe
          title="Map"
          src={siteInfo.mapEmbedUrl}
          className="w-full h-[420px] grayscale-[40%]"
          loading="lazy"
        />
      </section>
    </>
  );
};

export default Contact;
